<template>
  <q-page padding>
    <div class="row col-12 items-center justify-between q-mb-md">
      <div>
        <p class="text-h6 text-weight-bold text-brand-4 texto-titulo q-mb-0">
          Customização de Ficha de EPI
        </p>
        <span class="text-caption text-grey-8"
          >Configure os textos e visualize a pré-visualização da Ficha</span
        >
      </div>
      <div class="row q-gutter-sm items-center">
        <q-btn
          icon="visibility"
          outline
          label="Pré-visualizar"
          dense
          no-caps
          class="btn-preview"
          @click="preVisualizacao = true"
        />
        <q-btn
          v-if="!editando"
          icon="edit"
          label="Editar"
          dense
          no-caps
          class="btn-editar"
          @click="iniciarEdicao()"
        />
        <template v-else>
          <q-btn
            icon="cancel"
            color="negative"
            outline
            label="Cancelar"
            dense
            no-caps
            @click="cancelarEdicao()"
          />
          <q-btn
            icon="check_circle_outline"
            color="positive"
            label="Salvar"
            dense
            no-caps
            @click="alterarCabecalho()"
          />
        </template>
      </div>
    </div>

    <q-card flat bordered class="q-pa-md q-mb-lg">
      <div class="text-subtitle1 text-weight-bold text-brand-5 q-mb-xs">
        Configurações
      </div>
      <div class="text-caption text-grey-6 q-mb-md">
        Configure o conteúdo da ficha de EPI
      </div>

      <div class="row items-center q-gutter-md q-mb-lg">
        <div>
          <div class="q-mb-xs texto-titulo-input">Unidade</div>
          <lista-unidades-select v-model="unidade.nome" />
        </div>
        <div v-if="alterarLogo">
          <div class="q-mb-xs texto-titulo-input">Novo logo</div>
          <q-file
            dense
            outlined
            v-model="imagem"
            label="Alterar imagem"
            style="min-width: 180px"
          />
        </div>
        <q-btn
          :outline="!alterarLogo"
          :icon="alterarLogo ? 'add' : 'image'"
          :color="alterarLogo ? 'positive' : 'primary'"
          label="Alterar logo Impressão"
          dense
          no-caps
          style="margin-top: 42px"
          @click="alterarLogo ? trocarLogo() : (alterarLogo = true)"
        />
        <q-btn
          icon="content_copy"
          color="primary"
          :outline="!duplicarFicha"
          label="Duplicar a Ficha de EPI"
          dense
          no-caps
          style="margin-top: 42px"
          @click="duplicarFicha = !duplicarFicha"
        />
      </div>

      <div v-if="duplicarFicha" class="row q-gutter-sm q-mb-md items-end">
        <div class="col-md-2 col-sm-5 col-xs-12">
          <div class="q-mb-xs texto-titulo-input">Selecione a Unidade</div>
          <q-select
            option-label="nome"
            option-value="id"
            :options="listaUnidades"
            dense
            outlined
            v-model="unidadeDuplicar"
          />
        </div>
        <q-btn
          icon="check_circle_outline"
          color="positive"
          outline
          label="Duplicar Ficha"
          dense
          no-caps
        />
      </div>

      <div class="q-mb-md">
        <div class="q-mb-xs texto-titulo-input">Título da Ficha</div>
        <q-editor
          v-model="dados.tituloFicha"
          min-height="3rem"
          :toolbar="toolbarSimples"
          :disable="!editando"
          :class="{ 'editor-readonly': !editando }"
        />
      </div>

      <div class="q-mb-md">
        <div class="q-mb-xs texto-titulo-input">
          Descreva as Diretrizes da Ficha
        </div>
        <q-editor
          v-model="dados.diretrizesFicha"
          min-height="8rem"
          :toolbar="toolbarCompleto"
          :disable="!editando"
          :class="{ 'editor-readonly': !editando }"
        />
      </div>

      <div>
        <q-checkbox
          v-model="dados.rodape"
          :disable="disableRadio"
          label="Adicionar Rodapé"
          color="teal"
        />
      </div>
    </q-card>

    <q-dialog
      v-model="preVisualizacao"
      transition-show="rotate"
      transition-hide="rotate"
    >
      <q-card
        style="
          width: 92vw;
          max-width: 92vw;
          max-height: 92vh;
          display: flex;
          flex-direction: column;
        "
      >
        <q-card-section class="row items-center q-pb-none">
          <div>
            <div class="text-h6 text-brand-1">
              Pré-visualização da Ficha de EPI
            </div>
            <div class="text-caption text-grey-6">
              Visualize a ficha de EPI conforme as configurações feitas
            </div>
          </div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section style="overflow-y: auto; flex: 1">
          <div style="background: #f0f2f5; border-radius: 8px; padding: 24px">
            <div class="ficha-preview-wrap">
              <div class="row items-center q-mb-sm ficha-topo q-pb-md">
                <div style="width: 180px; flex-shrink: 0">
                  <q-img
                    v-if="dadosDescricao?.url_logo"
                    :src="dadosDescricao.url_logo"
                    style="max-height: 68px; max-width: 170px"
                    fit="contain"
                  />
                  <q-img
                    v-else
                    src="../../../assets/MULTPEX_VETOR.png"
                    style="max-height: 68px; max-width: 170px"
                    fit="contain"
                  />
                </div>
                <div
                  class="col text-center text-weight-bold"
                  v-html="
                    dados.tituloFicha ||
                    '<b>COMPROVANTE DE RECEBIMENTO DE MATERIAIS DE SEGURANÇA</b>'
                  "
                />
              </div>
              <q-separator class="q-mb-md" />

              <div
                class="q-mb-lg texto-preview-diretrizes"
                v-html="
                  dados.diretrizesFicha ||
                  'Recebi os equipamentos de proteção individual - EPI, obrigando-me a usá-los adequadamente durante a minha jornada de trabalho.'
                "
              />

              <q-table
                flat
                bordered
                dense
                :columns="columnsPreviewUsuario"
                :rows="rowsPreviewUsuario"
                hide-bottom
                class="q-mb-md preview-table"
                table-header-class="bg-grey-2 text-black text-weight-bold"
              />

              <q-table
                flat
                bordered
                dense
                :columns="columnsPreviewItens"
                :rows="rowsPreviewItens"
                hide-bottom
                class="q-mb-xl preview-table"
                table-header-class="bg-grey-2 text-black text-weight-bold"
              />

              <div v-if="dados.rodape" class="q-mt-lg">
                <p class="texto-preview-diretrizes">
                  Eu,
                  <strong>{{
                    usuarioLogadoDados
                      ? usuarioLogadoDados.name
                      : $store.state.autenticacao.usuarioLogado.nome
                  }}</strong>
                  reconheço que recebi os materiais acima descritos nas datas
                  acima indicadas
                </p>
                <div class="row justify-center q-mt-xl">
                  <div style="width: 340px; text-align: center">
                    <q-separator />
                    <div class="q-mt-sm text-weight-bold">
                      Assinatura do Colaborador
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat no-caps label="Fechar" color="brand-1" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const imagem = ref(null);
    const alterarLogo = ref(false);
    let duplicarFicha = ref(false);
    let editando = ref(false);
    let preVisualizacao = ref(false);
    const dadosBackup = ref({});

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const listaUnidades = ref([]);
    const unidadeDuplicar = ref({ nome: "", id: "" });
    const listaColunasEntrega = ref([]);
    const listaColunasUsuario = ref([]);
    const dados = ref({
      colunaEntrega: "",
      colunaUsuario: "",
      tituloFicha: "",
      diretrizesFicha: "",
      rodape: "",
      template: "",
    });
    const listaColunasEntregasAtivas = ref([]);
    const listaColunasUsuarioAtivas = ref([]);
    let disable = ref(false);
    let disableRadio = ref(false);

    const usuarioLogadoDados = ref(null);
    const dadosDescricao = ref(null);

    const carregarDescricao = async () => {
      try {
        const response = await store.dispatch("seguranca/getDescricao", {
          vendor_id: unidade.value.id,
        });
        dadosDescricao.value = response.data.response;
      } catch (error) {
        console.log(error);
      }
    };

    const carregarUsuarioLogado = async () => {
      try {
        const nomeUsuario = store.state.autenticacao.usuarioLogado?.nome;
        if (!nomeUsuario) return;
        const response = await store.dispatch("seguranca/listarUsuarios", {
          vendor_id: unidade.value.id,
          per_page: 1,
          search: nomeUsuario,
        });
        const resultado = response?.data?.results?.data;
        if (resultado && resultado.length > 0) {
          usuarioLogadoDados.value = resultado[0];
        }
      } catch (error) {
        console.log(error);
      }
    };

    // Toolbars do q-editor
    const toolbarSimples = [
      [
        {
          label: "Alinhamento",
          icon: "format_align_left",
          fixedLabel: true,
          list: "only-icons",
          options: ["left", "center", "right", "justify"],
        },
      ],
      ["bold", "italic", "underline", "strike"],
      [
        {
          label: "Formato",
          icon: "title",
          list: "no-icons",
          options: ["p", "h1", "h2", "h3", "h4", "h5", "h6"],
        },
      ],
      ["removeFormat"],
    ];

    const toolbarCompleto = [
      [
        {
          label: "Alinhamento",
          icon: "format_align_left",
          fixedLabel: true,
          list: "only-icons",
          options: ["left", "center", "right", "justify"],
        },
      ],
      ["bold", "italic", "underline", "strike"],
      [
        {
          label: "Formato",
          icon: "title",
          list: "no-icons",
          options: ["p", "h1", "h2", "h3", "h4", "h5", "h6"],
        },
      ],
      ["quote", "unordered", "ordered"],
      ["undo", "redo"],
      ["removeFormat"],
    ];

    // Pré-visualização — colunas do usuário
    const columnsPreviewUsuario = computed(() => {
      return [
        { name: "name", label: "Nome", align: "left", field: "name" },
        { name: "sap", label: "ID Usuário", align: "left", field: "sap" },
        {
          name: "dataAdmissao",
          label: "Data emissão",
          align: "left",
          field: "dataAdmissao",
        },
        {
          name: "dataDemissao",
          label: "Data devolução",
          align: "left",
          field: "dataDemissao",
        },
      ];
    });

    const rowsPreviewUsuario = computed(() => {
      const u = usuarioLogadoDados.value;
      if (!u) {
        return [{ name: "—", sap: "—", dataAdmissao: "—", dataDemissao: "—" }];
      }
      return [
        {
          name: u.name || "—",
          sap: u.sap || "—",
          dataAdmissao: u.admission_date
            ? u.admission_date.split(" ")[0].split("-").reverse().join("/")
            : "—",
          dataDemissao: u.demission_date
            ? u.demission_date.split(" ")[0].split("-").reverse().join("/")
            : "—",
          funcao: u.function || "—",
        },
      ];
    });

    // Pré-visualização — colunas dos itens
    const columnsPreviewItens = computed(() => {
      return [
        { name: "funcao", label: "Função/GHE", align: "left", field: "funcao" },
        { name: "area", label: "Área", align: "left", field: "area" },
        {
          name: "numVoucher",
          label: "Num Voucher",
          align: "left",
          field: "numVoucher",
        },
        {
          name: "entregueEm",
          label: "Data Emissão",
          align: "left",
          field: "entregueEm",
        },
        {
          name: "codProduto",
          label: "Cód. Produto",
          align: "left",
          field: "codProduto",
        },
        {
          name: "descricao",
          label: "Descrição",
          align: "left",
          field: "descricao",
        },
        { name: "ca", label: "CA", align: "left", field: "ca" },
        {
          name: "quantidade",
          label: "Quantidade",
          align: "left",
          field: "quantidade",
        },
        {
          name: "autCriacao",
          label: "Autenticação Criação",
          align: "left",
          field: "autCriacao",
        },
        {
          name: "autFinalizacao",
          label: "Autenticação Finalização",
          align: "left",
          field: "autFinalizacao",
        },
      ];
    });

    const rowsPreviewItens = ref([
      {
        planta: "Unidade 123",
        funcao: "Ger. HSE",
        centroCusto: "centro custo Primordial",
        area: "centro de custo Primordial",
        respCC: "João Silva",
        numVoucher: "22280",
        entregueEm: "17/03/2026",
        codProduto: "10382306",
        descricao: "Protetor Auricular Pomp Plus 3M",
        ca: "12345",
        quantidade: "1,0000",
        requisicao: "REQ-001",
        autCriacao: "Assinado eletronicamente",
        autFinalizacao: "Assinado eletronicamente",
      },
      {
        planta: "Unidade 123",
        funcao: "Ger. HSE",
        centroCusto: "centro custo Primordial",
        area: "centro de custo Primordial",
        respCC: "João Silva",
        numVoucher: "32254",
        entregueEm: "17/03/2026",
        codProduto: "10674501238/5",
        descricao: "Luva Vaqueta Punho 7cm",
        ca: "67890",
        quantidade: "5,0000",
        requisicao: "REQ-002",
        autCriacao: "Assinado eletronicamente",
        autFinalizacao: "Assinado eletronicamente",
      },
      {
        planta: "Unidade 123",
        funcao: "Ger. HSE",
        centroCusto: "centro custo Primordial",
        area: "centro de custo Primordial",
        respCC: "João Silva",
        numVoucher: "56365",
        entregueEm: "17/03/2026",
        codProduto: "23406745",
        descricao: "Luva Raspa Punho 15cm",
        ca: "87520",
        quantidade: "6,0000",
        requisicao: "REQ-002",
        autCriacao: "Assinado eletronicamente",
        autFinalizacao: "Assinado eletronicamente",
      },
    ]);

    const iniciarEdicao = () => {
      dadosBackup.value = {
        tituloFicha: dados.value.tituloFicha,
        diretrizesFicha: dados.value.diretrizesFicha,
        rodape: dados.value.rodape,
      };
      editando.value = true;
    };

    const cancelarEdicao = () => {
      dados.value.tituloFicha = dadosBackup.value.tituloFicha;
      dados.value.diretrizesFicha = dadosBackup.value.diretrizesFicha;
      dados.value.rodape = dadosBackup.value.rodape;
      editando.value = false;
    };

    const listarColunasEntrega = async () => {
      try {
        disable.value = true;
        await unidade.value.id;
        const response = await store.dispatch("office/listarColunasEntrega", {
          vendor_id: unidade.value.id,
        });
        let array = [
          "Planta",
          "Função/GHE",
          "Centro de Custo",
          "Área",
          "Resp. CC",
          "Num Voucher",
          "Entregue em",
          "Cód. Produto",
          "Descrição",
          "CA",
          "Quantidade",
          "Requisição",
          "Retirada",
        ];
        listaColunasEntregasAtivas.value = response.data.response;
        if (response.data.response != "") {
          response.data.response.forEach((coluna) => {
            if (coluna.ativo) {
              array = array.filter((col) => col != coluna.info_entrega);
            }
          });
        }
        listaColunasEntrega.value = array;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const getAssinatura = async () => {
      disableRadio.value = true;
      try {
        const response = await store.dispatch(
          "seguranca/receberConfiguracaoAssinaturaRodape"
        );
        if (response.data.data.length > 0) {
          let array = [];
          array = response.data.data.filter(
            (unidade) => unidade.id === store.state.org.unidadeData.id
          );
          dados.value.rodape = array[0].mostrar ? true : false;
        }
        disableRadio.value = false;
      } catch (error) {
        console.log(error);
        disableRadio.value = false;
      }
    };

    const alterarConfiguracaoAssinaturaRodape = async () => {
      try {
        await store.dispatch("seguranca/alterarConfiguracaoAssinaturaRodape", {
          vendor_id: store.state.org.unidadeData.id,
          mostrar: dados.value.rodape,
        });
        getAssinatura();
      } catch (error) {
        console.log(error);
        disableRadio.value = false;
      }
    };

    const listarColunasUsuario = async () => {
      try {
        disable.value = true;
        await unidade.value.id;
        const response = await store.dispatch("office/listarColunasUsuario", {
          vendor_id: unidade.value.id,
        });
        let array = [
          "Nome",
          "ID Usuário",
          "Data admissão",
          "Data demissão",
          "Cargo",
          "Função/GHE",
        ];
        listaColunasUsuarioAtivas.value = response.data.response;
        if (response.data.response != "") {
          response.data.response.forEach((coluna) => {
            if (coluna.ativo) {
              array = array.filter((col) => col != coluna.info_usuario);
            }
          });
        }
        listaColunasUsuario.value = array;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const ativarColunaEntrega = async (coluna) => {
      try {
        await store.dispatch("office/ativarDesativarColunaEntrega", {
          vendor_id: unidade.value.id,
          info_entrega: coluna,
          ativo: true,
        });
        dados.value.colunaEntrega = "";
        listarColunasEntrega();
        quasar.notify({
          message: "Coluna ativada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao ativar coluna",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const ativarColunaUsuario = async (coluna) => {
      try {
        await store.dispatch("office/ativarDesativarColunaUsuario", {
          vendor_id: unidade.value.id,
          info_usuario: coluna,
          ativo: true,
        });
        dados.value.colunaUsuario = "";
        listarColunasUsuario();
        quasar.notify({
          message: "Coluna ativada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao ativar coluna",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const desativarColunaEntrega = async (coluna) => {
      try {
        await store.dispatch("office/ativarDesativarColunaEntrega", {
          vendor_id: unidade.value.id,
          info_entrega: coluna,
          ativo: false,
        });
        listarColunasEntrega();
        quasar.notify({
          message: "Coluna desativada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao desativar coluna",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const desativarColunaUsuario = async (coluna) => {
      try {
        await store.dispatch("office/ativarDesativarColunaUsuario", {
          vendor_id: unidade.value.id,
          info_usuario: coluna,
          ativo: false,
        });
        listarColunasUsuario();
        quasar.notify({
          message: "Coluna desativada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao desativar coluna",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        listaUnidades.value = response.listaUnidades;
      } catch (error) {
        console.log(error);
      }
    };

    const trocarLogo = async () => {
      if (imagem.value == null) {
        quasar.notify({
          message: "Selecione uma imagem",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        return;
      }
      try {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(imagem.value);
        fileReader.addEventListener("load", async () => {
          try {
            await store.dispatch("seguranca/uploadImagemLogo", {
              imagem: fileReader.result,
              vendor_id: unidade.value.id,
            });
            quasar.notify({
              message: "Imagem enviada com sucesso",
              color: "positive",
              actions: [{ label: "Fechar", color: "white", handler: () => {} }],
            });
            imagem.value = null;
          } catch (error) {
            quasar.notify({
              message: "Erro ao enviar imagem",
              color: "negative",
              actions: [{ label: "Fechar", color: "white", handler: () => {} }],
            });
          }
        });
        alterarLogo.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro ao enviar imagem",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        console.log(error);
      }
    };

    const receberCabecalho = async () => {
      try {
        await unidade.value.id;
        const response = await store.dispatch("office/receberCabecalho", {
          vendor_id: unidade.value.id,
        });
        if (response.data.response != null) {
          const array = response.data.response;
          dados.value.tituloFicha = array.titulo;
          dados.value.diretrizesFicha = array.cabecalho;
          return;
        }
        dados.value.tituloFicha = "";
        dados.value.diretrizesFicha = "";
        dados.value.rodape = "";
      } catch (error) {
        console.log(error);
      }
    };

    const alterarCabecalho = async () => {
      if (
        !dados.value.tituloFicha ||
        dados.value.tituloFicha === "" ||
        dados.value.tituloFicha === "<p><br></p>"
      ) {
        quasar.notify({
          message: "Preencha o campo de titulo da ficha",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        return;
      }
      if (dados.value.rodape != true && dados.value.rodape != false) {
        quasar.notify({
          message: "Selecione uma opção de assinatura",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        return;
      }
      try {
        await store.dispatch("office/alterarCabecalho", {
          vendor_id: unidade.value.id,
          cabecalho: dados.value.diretrizesFicha,
          titulo: dados.value.tituloFicha,
          rodape: dados.value.rodape,
          template: dados.value.template,
        });
        await alterarConfiguracaoAssinaturaRodape();
        receberCabecalho();
        editando.value = false;
        quasar.notify({
          message: "Customização salva com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao salvar customização",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarColunasEntrega();
        listarColunasUsuario();
        receberCabecalho();
      }
    );

    watch(
      () => dados.value.colunaEntrega,
      () => {
        if (dados.value.colunaEntrega != "") {
          ativarColunaEntrega(dados.value.colunaEntrega);
        }
      }
    );

    watch(
      () => dados.value.colunaUsuario,
      () => {
        if (dados.value.colunaUsuario != "") {
          ativarColunaUsuario(dados.value.colunaUsuario);
        }
      }
    );

    onMounted(listarColunasEntrega);
    onMounted(listarUnidades);
    onMounted(listarColunasUsuario);
    onMounted(receberCabecalho);
    onMounted(getAssinatura);
    onMounted(carregarUsuarioLogado);
    onMounted(carregarDescricao);

    return {
      duplicarFicha,
      editando,
      preVisualizacao,
      iniciarEdicao,
      cancelarEdicao,
      listarColunasEntrega,
      unidade,
      listarUnidades,
      listaUnidades,
      unidadeDuplicar,
      listaColunasEntrega,
      dados,
      ativarColunaEntrega,
      listaColunasEntregasAtivas,
      desativarColunaEntrega,
      disable,
      alterarConfiguracaoAssinaturaRodape,
      listarColunasUsuario,
      listaColunasUsuarioAtivas,
      listaColunasUsuario,
      desativarColunaUsuario,
      receberCabecalho,
      alterarCabecalho,
      imagem,
      alterarLogo,
      trocarLogo,
      disableRadio,
      toolbarSimples,
      toolbarCompleto,
      columnsPreviewUsuario,
      rowsPreviewUsuario,
      columnsPreviewItens,
      rowsPreviewItens,
      usuarioLogadoDados,
      carregarUsuarioLogado,
      dadosDescricao,
      carregarDescricao,
    };
  },
};
</script>

<style scoped>
.card-coluna {
  background-color: #dfebf2;
  padding: 4px 4px 6px 20px;
  border-radius: 5px;
}

.editor-readonly {
  opacity: 0.85;
}
.editor-readonly :deep(.q-editor__content) {
  background-color: #f8f9fa;
}

.btn-preview {
  color: #37474f !important;
  border-color: #b0bec5 !important;
}

.btn-editar {
  background-color: #00897b !important;
  color: white !important;
}

/* Modal pré-visualização */
.ficha-preview-wrap {
  width: 100%;
  max-width: 100%;
  background: white;
  padding: 40px 52px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

.ficha-topo {
  border-bottom: 1px solid #e0e0e0;
}

.texto-preview-diretrizes {
  text-align: justify;
  font-size: 14px;
  line-height: 1.7;
}

.preview-table {
  font-size: 13px;
}
</style>
